import styled from 'styled-components'

export const Image = styled.img.attrs(props => ({
  role: 'img',
  alt: props.alt ?? '',
}))``
